import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const TopAlert = ({ message, type = "info", duration = 3000, onClose }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (message) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        if (onClose) onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  const colors = {
    info: "bg-blue-500",
    success: "bg-green-500",
    error: "bg-red-500",
    warning: "bg-yellow-500",
  };

  const variants = {
    hidden: { y: -50, opacity: 0 },
    visible: { y: 0, opacity: 1 },
    exit: { y: -50, opacity: 0 },
  };

  // Convert string with \n to array for rendering
const renderMessage = () => {
  if (!message) return null;

  const lines = message.split("\n");
  return (
    <div>
      <p className="font-semibold mb-1">{lines[0]}</p> {/* heading */}
      <ul className="list-disc pl-5">
        {lines.slice(1).map((line, idx) => (
          <li key={idx}>{line}</li>
        ))}
      </ul>
    </div>
  );
};


  return (
    <AnimatePresence>
      {show && message && (
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={variants}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
          className={`
            fixed top-0 left-0 right-0 sm:left-1/2 sm:right-auto sm:transform sm:-translate-x-1/2 z-50
            px-4 sm:px-6 py-3 rounded-b sm:rounded shadow-lg text-white font-semibold
            ${colors[type]}
          `}
        >
          {renderMessage()}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TopAlert;
